import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import SortSelect from '@/views/components/SortSelect.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
// «ترتيب» on every students / teachers list
Vue.component('SortSelect', SortSelect)
